var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vl-tab',{style:(_vm.$_elementStyles),attrs:{"name":_vm.$_label,"active":_vm.isActive}},_vm._l((_vm.komponents),function(tab,index){return _c('component',_vm._b({key:index},'component',_vm.$_attributes(tab),false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }